import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Rating} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const paises=[{ key:1, value:1, text: 'Albania' },
{ key:2, value:2, text: 'Alemania' },
{ key:3, value:3, text: 'Andorra' },
{ key:4, value:4, text: 'Angola' },
{ key:5, value:5, text: 'Antigua y Barbuda' },
{ key:6, value:6, text: 'Arabia Saudita' },
{ key:7, value:7, text: 'Argelia' },
{ key:8, value:8, text: 'Argentina' },
{ key:9, value:9, text: 'Armenia' },
{ key:10, value:10, text: 'Australia' },
{ key:11, value:11, text: 'Austria' },
{ key:12, value:12, text: 'Azerbaiyán' },
{ key:13, value:13, text: 'Bahamas' },
{ key:14, value:14, text: 'Bahrein' },
{ key:15, value:15, text: 'Bangladesh' },
{ key:16, value:16, text: 'Barbados' },
{ key:17, value:17, text: 'Belarús' },
{ key:18, value:18, text: 'Belice' },
{ key:19, value:19, text: 'Benin' },
{ key:20, value:20, text: 'Bhután' },
{ key:21, value:21, text: 'Bolivia (Estado Plurinacional de)' },
{ key:22, value:22, text: 'Bosnia y Herzegovina' },
{ key:23, value:23, text: 'Botswana' },
{ key:24, value:24, text: 'Brasil' },
{ key:25, value:25, text: 'Brunei Darussalam' },
{ key:26, value:26, text: 'Bulgaria' },
{ key:27, value:27, text: 'Burkina Faso' },
{ key:28, value:28, text: 'Burundi' },
{ key:29, value:29, text: 'Bélgica' },
{ key:30, value:30, text: 'Cabo Verde' },
{ key:31, value:31, text: 'Camboya' },
{ key:32, value:32, text: 'Camerún' },
{ key:33, value:33, text: 'Canadá' },
{ key:34, value:34, text: 'Chad' },
{ key:35, value:35, text: 'Chequia' },
{ key:36, value:36, text: 'Chile' },
{ key:37, value:37, text: 'China' },
{ key:38, value:38, text: 'Chipre' },
{ key:39, value:39, text: 'Colombia' },
{ key:40, value:40, text: 'Comoras' },
{ key:41, value:41, text: 'Congo' },
{ key:42, value:42, text: 'Costa Rica' },
{ key:43, value:43, text: 'Croacia' },
{ key:44, value:44, text: 'Cuba' },
{ key:45, value:45, text: "Côte d'Ivoire" },
{ key:46, value:46, text: 'Dinamarca' },
{ key:47, value:47, text: 'Djibouti' },
{ key:48, value:48, text: 'Dominica' },
{ key:49, value:49, text: 'Ecuador' },
{ key:50, value:50, text: 'Egipto' },
{ key:51, value:51, text: 'El Salvador' },
{ key:52, value:52, text: 'Emiratos Árabes Unidos' },
{ key:53, value:53, text: 'Eritrea' },
{ key:54, value:54, text: 'Eslovaquia' },
{ key:55, value:55, text: 'Eslovenia' },
{ key:56, value:56, text: 'España' },
{ key:57, value:57, text: 'Estados Unidos de América' },
{ key:58, value:58, text: 'Estonia' },
{ key:59, value:59, text: 'Eswatini' },
{ key:60, value:60, text: 'Etiopía' },
{ key:61, value:61, text: 'Federación de Rusia' },
{ key:62, value:62, text: 'Fiji' },
{ key:63, value:63, text: 'Filipinas' },
{ key:64, value:64, text: 'Finlandia' },
{ key:65, value:65, text: 'Francia' },
{ key:66, value:66, text: 'Gabón' },
{ key:67, value:67, text: 'Gambia' },
{ key:68, value:68, text: 'Georgia' },
{ key:69, value:69, text: 'Ghana' },
{ key:70, value:70, text: 'Granada' },
{ key:71, value:71, text: 'Grecia' },
{ key:72, value:72, text: 'Guatemala' },
{ key:73, value:73, text: 'Guinea' },
{ key:74, value:74, text: 'Guinea Ecuatorial' },
{ key:75, value:75, text: 'Guinea-Bissau' },
{ key:76, value:76, text: 'Guyana' },
{ key:77, value:77, text: 'Haití' },
{ key:78, value:78, text: 'Honduras' },
{ key:79, value:79, text: 'Hungría' },
{ key:80, value:80, text: 'India' },
{ key:81, value:81, text: 'Indonesia' },
{ key:82, value:82, text: 'Iraq' },
{ key:83, value:83, text: 'Irlanda' },
{ key:84, value:84, text: 'Irán (República Islámica del)' },
{ key:85, value:85, text: 'Islandia' },
{ key:86, value:86, text: 'Islas Cook' },
{ key:87, value:87, text: 'Islas Feroe' },
{ key:88, value:88, text: 'Islas Marshall' },
{ key:89, value:89, text: 'Islas Salomón' },
{ key:90, value:90, text: 'Israel' },
{ key:91, value:91, text: 'Italia' },
{ key:92, value:92, text: 'Jamaica' },
{ key:93, value:93, text: 'Japón' },
{ key:94, value:94, text: 'Jordania' },
{ key:95, value:95, text: 'Kazajstán' },
{ key:96, value:96, text: 'Kenya' },
{ key:97, value:97, text: 'Kirguistán' },
{ key:98, value:98, text: 'Kiribati' },
{ key:99, value:99, text: 'Kuwait' },
{ key:100, value:100, text: 'Lesotho' },
{ key:101, value:101, text: 'Letonia' },
{ key:102, value:102, text: 'Liberia' },
{ key:103, value:103, text: 'Libia' },
{ key:104, value:104, text: 'Lituania' },
{ key:105, value:105, text: 'Luxemburgo' },
{ key:106, value:106, text: 'Líbano' },
{ key:107, value:107, text: 'Macedonia del Norte' },
{ key:108, value:108, text: 'Madagascar' },
{ key:109, value:109, text: 'Malasia' },
{ key:110, value:110, text: 'Malawi' },
{ key:111, value:111, text: 'Maldivas' },
{ key:112, value:112, text: 'Malta' },
{ key:113, value:113, text: 'Malí' },
{ key:114, value:114, text: 'Marruecos' },
{ key:115, value:115, text: 'Mauricio' },
{ key:116, value:116, text: 'Mauritania' },
{ key:117, value:117, text: 'Micronesia (Estados Federados de)' },
{ key:118, value:118, text: 'Mongolia' },
{ key:119, value:119, text: 'Montenegro' },
{ key:120, value:120, text: 'Mozambique' },
{ key:121, value:121, text: 'Myanmar' },
{ key:122, value:122, text: 'México' },
{ key:123, value:123, text: 'Mónaco' },
{ key:124, value:124, text: 'Namibia' },
{ key:125, value:125, text: 'Nauru' },
{ key:126, value:126, text: 'Nepal' },
{ key:127, value:127, text: 'Nicaragua' },
{ key:128, value:128, text: 'Nigeria' },
{ key:129, value:129, text: 'Niue' },
{ key:130, value:130, text: 'Noruega' },
{ key:131, value:131, text: 'Nueva Zelandia' },
{ key:132, value:132, text: 'Níger' },
{ key:133, value:133, text: 'Omán' },
{ key:134, value:134, text: 'Pakistán' },
{ key:135, value:135, text: 'Palau' },
{ key:136, value:136, text: 'Panamá' },
{ key:137, value:137, text: 'Papua Nueva Guinea' },
{ key:138, value:138, text: 'Paraguay' },
{ key:139, value:139, text: 'Países Bajos' },
{ key:140, value:140, text: 'Perú' },
{ key:141, value:141, text: 'Polonia' },
{ key:142, value:142, text: 'Portugal' },
{ key:143, value:143, text: 'Qatar' },
{ key:144, value:144, text: 'Reino Unido de Gran Bretaña e Irlanda del Norte' },
{ key:145, value:145, text: 'República Centroafricana' },
{ key:146, value:146, text: 'República Democrática Popular Lao' },
{ key:147, value:147, text: 'República Democrática del Congo' },
{ key:148, value:148, text: 'República Dominicana' },
{ key:149, value:149, text: 'República Popular Democrática de Corea' },
{ key:150, value:150, text: 'República Unida de Tanzanía' },
{ key:151, value:151, text: 'República de Corea' },
{ key:152, value:152, text: 'República de Moldova' },
{ key:153, value:153, text: 'República Árabe Siria' },
{ key:154, value:154, text: 'Rumania' },
{ key:155, value:155, text: 'Rwanda' },
{ key:156, value:156, text: 'Saint Kitts y Nevis' },
{ key:157, value:157, text: 'Samoa' },
{ key:158, value:158, text: 'San Marino' },
{ key:159, value:159, text: 'San Vicente y las Granadinas' },
{ key:160, value:160, text: 'Santa Lucía' },
{ key:161, value:161, text: 'Santo Tomé y Príncipe' },
{ key:162, value:162, text: 'Senegal' },
{ key:163, value:163, text: 'Serbia' },
{ key:164, value:164, text: 'Seychelles' },
{ key:165, value:165, text: 'Sierra Leona' },
{ key:166, value:166, text: 'Singapur' },
{ key:167, value:167, text: 'Somalia' },
{ key:168, value:168, text: 'Sri Lanka' },
{ key:169, value:169, text: 'Sudáfrica' },
{ key:170, value:170, text: 'Sudán' },
{ key:171, value:171, text: 'Sudán del Sur' },
{ key:172, value:172, text: 'Suecia' },
{ key:173, value:173, text: 'Suiza' },
{ key:174, value:174, text: 'Suriname' },
{ key:175, value:175, text: 'Tailandia' },
{ key:176, value:176, text: 'Tayikistán' },
{ key:177, value:177, text: 'Timor-Leste' },
{ key:178, value:178, text: 'Togo' },
{ key:179, value:179, text: 'Tokelau' },
{ key:180, value:180, text: 'Tonga' },
{ key:181, value:181, text: 'Trinidad y Tabago' },
{ key:182, value:182, text: 'Turkmenistán' },
{ key:183, value:183, text: 'Turquía' },
{ key:184, value:184, text: 'Tuvalu' },
{ key:185, value:185, text: 'Túnez' },
{ key:186, value:186, text: 'Ucrania' },
{ key:187, value:187, text: 'Uganda' },
{ key:188, value:188, text: 'Uruguay' },
{ key:189, value:189, text: 'Uzbekistán' },
{ key:190, value:190, text: 'Vanuatu' },
{ key:191, value:191, text: 'Venezuela (República Bolivariana de)' },
{ key:192, value:192, text: 'Viet Nam' },
{ key:193, value:193, text: 'Yemen' },
{ key:194, value:194, text: 'Zambia' },
{ key:195, value:195, text: 'Zimbabwe' }];

/*

                        
                                            
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
*/


const CursoOpinionForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, cursoCombo, onChangeRate})=>{

	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["CursoOpinion"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.idCurso}>
                              <label  >{strings?strings["idCurso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idCurso"]:""} 
                                    name="idCurso"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idCurso}
                                    options={cursoCombo}/>
                            </Form.Field>                
        
        
                            <Form.Field  required  error={errors.idPais}>
                              <label  >{strings?strings["idPais"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idPais"]:""} 
                                    name="idPais"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idPais}
                                    options={paises}/>
                            </Form.Field>    
        
        
        
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
        
                            <Rating icon='star' 
                                    defaultRating={3} 
                                    rating={datos.calificacion}
                                    maxRating={5}
                                    onRate={(event, data)=>onChangeRate(event, data)}
                                />
                                            
                    
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoopinions">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoOpinionForm;